import HTTP from '@/components/general/http/http'
import Routes from '@/router/routes'
import config from '@/config/env'

export default {
	login(data) {

		let url = config.api.baseUrl + '/api/authentication/login'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	logout() {

		let url = config.api.baseUrl + '/api/authentication/logout'

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)

	},
	session() {

		let url = config.api.baseUrl + '/api/authentication/session'

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(err => {

				let headerToDelete = {
					key: 'x-parse-session-token'
				}

				HTTP.deleteHeader(headerToDelete)
				localStorage.removeItem('sessionToken')
				localStorage.removeItem('sessionUser')

				window.location.href = Routes.login.path

				return err

			})

	}
}



// WEBPACK FOOTER //
// ./src/api/authentication.js